<main class="home-dashboard" [@fadeIn]>
  <app-dashboard></app-dashboard>
</main>